





import Loading from './modules/loading';


import DataTable from 'datatables.net-dt';

// Import modules
import Empresa from "./modules/empresa";
import Candidato from "./modules/Candidato";
import Vaga from "./modules/Vaga";
import Formacao from "./modules/Formacao";
import Sector from "./modules/SectorActividade";
import PDF from "./modules/GerarPDF";
import SmsReport from "./modules/SmsReport";

import dataTablesPortugueseLang from "./modules/datablesPt";


const  loading = new Loading()
//Inicialize objects
const ep =  new Empresa(loading);
const cd =  new Candidato(loading);
const vg =  new Vaga(loading);
const formacao =  new Formacao(loading);
const sector =  new Sector(loading);
const pdf =  new PDF(loading);
const sms = new SmsReport(loading);



 
let table = new DataTable('#myTable', {
    language: dataTablesPortugueseLang,

    columnDefs: [
        {
          targets: [1], // Column index to target, starts from 0
          orderable: false, // Disable ordering for this column
        },
    ]
});






